import DeleteDashboardCriteria from 'use-case/dashboard/delete/deleteDashboardCriteria';
import { getNoContentApiClient } from 'adapter/out/client/apiClient';

export default getNoContentApiClient(
    (criteria: DeleteDashboardCriteria) => `dashboards/dashboards/${criteria.id}`,
    () => ({
        method: 'DELETE',
        body: undefined,
        headers: { 'Content-Type': 'application/json' },
    })
);
